import { useEffect } from 'react';
import { AD_CLASSES } from '../constants/classNames';
import { ADSENSE_CLIENT_ID, IS_AD_UNIT_VISIBLE } from '../constants/config';
import { loadAdSenseScript, requestAdFill } from '../utils/adsenseUtils';
import '../styles/AdSlot.css';

/**
 * One responsive AdSense ad. Every request is tagged for child-directed treatment
 * (data-tag-for-age-treatment="1"), so Google only shows ads that suit a kids' site:
 * no interest-based or remarketing ads. Renders nothing until AdSense is configured and
 * IS_AD_UNIT_VISIBLE is switched on.
 */
export default function AdSlot({ slotId }) {
  const isConfigured = Boolean(IS_AD_UNIT_VISIBLE && ADSENSE_CLIENT_ID && slotId);

  useEffect(() => {
    if (!isConfigured) return;
    loadAdSenseScript(ADSENSE_CLIENT_ID);
    requestAdFill();
  }, [isConfigured, slotId]);

  if (!isConfigured) return null;
  return (
    <aside className={AD_CLASSES.root} aria-label="Advertisement">
      <span className={AD_CLASSES.label}>Advertisement</span>
      <ins
        className={AD_CLASSES.unit}
        style={{ display: 'block' }}
        data-ad-client={ADSENSE_CLIENT_ID}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
        data-tag-for-age-treatment="1"
      />
    </aside>
  );
}
